import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import NuevaGestionPage from './pages/NuevaGestionPage';
import MisGestionesPage from './pages/MisGestionesPage';
import GestionDetailPage from './pages/GestionDetailPage';
import MapPage from './pages/MapPage';
import NotificacionesPage from './pages/NotificacionesPage';
import SeccionesPage from './pages/SeccionesPage';
import FuncionariosPage from './pages/FuncionariosPage';
import EquipoPage from './pages/EquipoPage';
import AuthCallback from './pages/AuthCallback';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="w-10 h-10 border-2 border-[#0052FF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function AuthRoute() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="w-10 h-10 border-2 border-[#0052FF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (user) return <Navigate to="/dashboard" replace />;
  return <LoginPage />;
}

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth callback via URL fragment (synchronous during render to avoid race).
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<AuthRoute />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/nueva-gestion" element={<ProtectedRoute roles={['brigadista', 'funcionario', 'admin']}><NuevaGestionPage /></ProtectedRoute>} />
      <Route path="/mis-gestiones" element={<ProtectedRoute><MisGestionesPage /></ProtectedRoute>} />
      <Route path="/gestion/:id" element={<ProtectedRoute><GestionDetailPage /></ProtectedRoute>} />
      <Route path="/mapa" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
      <Route path="/notificaciones" element={<ProtectedRoute roles={['gestion', 'funcionario', 'admin']}><NotificacionesPage /></ProtectedRoute>} />
      <Route path="/secciones" element={<ProtectedRoute roles={['admin', 'gestion', 'funcionario', 'brigadista']}><SeccionesPage /></ProtectedRoute>} />
      <Route path="/funcionarios" element={<ProtectedRoute roles={['admin']}><FuncionariosPage /></ProtectedRoute>} />
      <Route path="/equipo" element={<ProtectedRoute roles={['funcionario', 'admin']}><EquipoPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
        <InstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
